import React, { useState, useEffect, useCallback } from 'react';
import MapModal from '../components/MapModal';
import {
    getAllSlot,
    getClientById,
    getAllCentre,
    getAllClients,
    getAllEmployees,
    clientTaskCreate,
    getAllTask,
    getCentreById,
    updateClientTask
} from "../Services/masterService"
import TaskViewModal from '../components/TaskViewModal';
import UpdateTaskModal from './UpdateTaskModal';
import CancelClientTaskModal from '../components/CancelClientTask';
import Modal from '../AlertModal/Modal';

// Dummy list of available resources for dropdowns
const mockClients = [{ id: 'CL-001', name: 'City Lab Pvt Ltd' }, { id: 'CL-002', name: 'Health Diagnostics' }];
const mockSlots = [{ id: 1, time: '09:00 - 11:00' }, { id: 2, time: '11:00 - 13:00' }];
const mockCentres = [{ id: 'Centre A', name: 'Central Lab A' }, { id: 'Centre B', name: 'Satellite Centre B' }];
const mockEmployees = [{ id: 'EMP-101', name: 'Rajesh Sharma' }, { id: 'EMP-102', name: 'Priya Singh' }];

// Helper to format ISO date to separate date and time strings
const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const dateStr = date.toISOString().split('T')[0]; // YYYY-MM-DD
    const timeStr = date.toTimeString().substring(0, 5); // HH:MM
    return { dateStr, timeStr };
};



const initialFormState = {
    taskType: "Sample Pickup Request",
    preferredDate: new Date().toISOString().split('T')[0], // YYYY-MM-DD
    slotId: 1,
    pickupClientId: mockClients[0]?.clientCode || '', // Keep for lookup
    pickupAddress: "",
    pickupLatitude: 22.5726,
    pickupLongitude: 88.3639,
    dropCentreId: mockCentres[0]?.centreCode || '',
    dropAddress: "",
    dropLatitude: 22.5678,
    dropLongitude: 88.3745,
    priority: "NORMAL",
    description: "",
    createdBy: null,
    createdByType: "CLIENT"
};


// =================================================================
// MAIN TASK SCHEDULER COMPONENT
// =================================================================

function ClientTask() {
    const [taskList, setTaskList] = useState([]);

    const [formData, setFormData] = useState(initialFormState);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [apiMessage, setApiMessage] = useState({ type: '', text: '' });
    const [userInfo, setUserInfo] = useState('unkknowne')
    const [clientInfo, setClientInfo] = useState('')
    const [centreInfo, setCentreInfo] = useState('')
    const { preferredDate, preferredTime } = formData;
    const preferredDateTime = new Date(`${preferredDate}T${preferredTime}:00.000Z`);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState({});

    const showSuccess = (msg) => {
        setModalConfig({
            title: "Success!",
            message: msg,
            type: "success",
        });
        setIsModalOpen(true);
    };

    const showError = (titleMsg, message) => {
        setModalConfig({
            title: titleMsg,
            message: message,
            type: "error",
        });
        setIsModalOpen(true);
    };

    // API Call to Fetch Data
    const fetchTasks = useCallback(async () => {
        setIsLoading(true);
        setApiMessage({ type: '', text: '' });
        const storedUser = localStorage.getItem('user');
        const userInfo = JSON.parse(storedUser)
        try {
            const response = await getAllTask(userInfo.id);
            if (response.status == 1 && response.data.length > 0) {
                setTaskList(response.data.filter(item => item.createdBy === "CLIENT"));
            } else {
                // setApiMessage({ type: 'error', text: 'Failed to fetch task list.' });
            }
        } catch (error) {
            setApiMessage({ type: 'error', text: 'Network error occurred while fetching data.' });
        } finally {
            setIsLoading(false);
        }
        try {
            const storedUser = localStorage.getItem('user');
            const userId = JSON.parse(storedUser)
            if (userId) {
                const response = await getClientById(userId.id);
                if (response.status === 1 && response.data) {
                    setClientInfo(response.data);
                    setTimeout(async () => {
                        const cenreResponse = await getCentreById(response.data.centre);
                        console.log('centre response: ', cenreResponse.data)
                        if (cenreResponse.status == 1) {
                            setCentreInfo(cenreResponse.data)
                        } else {
                            setCentreInfo('')
                        }
                    }, 1000);
                } else {
                    setApiMessage({ type: 'error', text: 'Failed to fetch Client details.' });
                }
            }
        } catch (error) {
            setApiMessage({ type: 'error', text: 'Network error occurred while fetching data.' });
        } finally {
            setIsLoading(false);
        }
    }, []);

    // Load initial data on mount
    useEffect(() => {
        const loadData = async () => {
            const storedUser = localStorage.getItem('user');
            if (storedUser) {
                setUserInfo(JSON.parse(storedUser));
            }
            await fetchTasks();
        };

        loadData();

    }, [fetchTasks]); // Dependency array remains the same

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Handle form submission and API call
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setApiMessage({ type: '', text: '' });

        const {
            preferredDate,
            slotId,
            priority,
            description
        } = formData;

        const payload = {
            pickupClientId: clientInfo.id,
            taskType: "Sample Pickup Request",
            preferredDate: preferredDate,
            slotId: parseInt(slotId, 10),
            pickupAddress: clientInfo.area,
            pickupLatitude: String(clientInfo.latitude),
            pickupLongitude: String(clientInfo.longitude),
            dropCentreId: clientInfo.centre,
            dropAddress: centreInfo.address,
            dropLatitude: String(centreInfo.latitude),
            dropLongitude: String(centreInfo.longitude),
            priority: priority,
            description: description,
            createdBy: String(userInfo?.id),
            createdBy: "CLIENT",
            createdById: userInfo.id

        };

        try {
            const response = await clientTaskCreate(payload);

            if (response.status === 1) {
                const newTaskForState = {
                    ...payload,
                    ...response.data, // This will add/overwrite keys like `id`, `status`, etc.
                };
                setTaskList(prev => [...prev, newTaskForState]);
                // alert('Task scheduled successfully!');
                showSuccess(`Task scheduled successfully!`);
                setFormData(initialFormState); // Reset form
            } else {
                // alert('Failed to schedule task.');
                showError("Sorry!", "Failed to schedule task.");
            }
        } catch (error) {
            console.error(error);
            // setApiMessage({ type: 'error', text: 'Error submitting task to the server.' });
            showError("Network Error", `Could not connect to the server. Details: ${error.message}`);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="bg-gray-50">
            <div className="main-wrap">
                <div className="container">
                    <div className="title">
                        <h4>Logistics Task Scheduler</h4>
                    </div>

                    {/* API Message Display */}
                    {apiMessage.text && (
                        <div className={`p-3 mb-6 rounded ${apiMessage.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                            {apiMessage.text}
                        </div>
                    )}

                    {/* Task Form */}
                    <TaskForm
                        formData={formData}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                        setFormData={setFormData}
                    />

                    {/* Task List Table */}
                    <TaskList
                        showAlerts={{ showSuccess, showError }}
                        data={taskList}
                        isLoading={isLoading}
                    />

                    <Modal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        title={modalConfig.title}
                        message={modalConfig.message}
                        type={modalConfig.type}
                    />
                </div>
            </div>
        </div>

    );
}

// =================================================================
// TASK FORM COMPONENT
// =================================================================

const TaskForm = ({ formData, handleChange, handleSubmit, isSubmitting, setFormData }) => {
    const [isMapOpen, setIsMapOpen] = useState(false);
    const [mapTarget, setMapTarget] = useState(null); // 'pickup' or 'drop'

    const [slotList, setSlotList] = useState([]);
    const [centreList, setCentretList] = useState([]);
    const [clientList, setClienttList] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);


    const handleCloseMap = () => setIsMapOpen(false);

    // ✅ Function to open map for a specific target (Pickup or Drop)
    const handleOpenMap = (target) => {
        setMapTarget(target);
        setIsMapOpen(true);
    };

    const fetchTasks = useCallback(async () => {
        // setIsLoading(true);
        // setApiMessage({ type: '', text: '' });

        try {
            const response = await getAllSlot();
            if (response.status === 1) {
                setSlotList(response.data.filter(slot => (slot.status == "ACTIVE")));
            } else {
                setSlotList([]);
            }
        } catch (error) {
            alert({ type: 'error', text: 'Network error occurred while fetching data.' });
        } finally {
            // setIsLoading(false);
        }
        try {
            const response = await getAllCentre();
            if (response.status === 1) {
                setCentretList(response.data.filter(centre => (centre.status == "ACTIVE")));
            } else {
                setCentretList([]);
            }
        } catch (error) {
            alert({ type: 'error', text: 'Network error occurred while fetching data.' });
        } finally {
            // setIsLoading(false);
        }
        try {
            const response = await getAllClients();
            if (response.status === 1) {
                setClienttList(response.data.filter(client => (client.status == "ACTIVE")));
            } else {
                alert({ type: 'error', text: 'Failed to fetch task list.' });
            }
        } catch (error) {
            alert({ type: 'error', text: 'Network error occurred while fetching data.' });
        } finally {
            // setIsLoading(false);
        }
        try {
            const response = await getAllEmployees();
            if (response.status === 1) {
                setEmployeeList(response.data.filter(item => item.userType == "LOGISTIC" && item.status === "ACTIVE"));
            } else {
                alert({ type: 'error', text: 'Failed to fetch task list.' });
            }
        } catch (error) {
            alert({ type: 'error', text: 'Network error occurred while fetching data.' });
        } finally {
            // setIsLoading(false);
        }
    }, []);

    // Load initial data on mount
    useEffect(() => {
        fetchTasks();
    }, [fetchTasks]);



    // ✅ Callback from MapModal to save coordinates
    const handleSaveLatLong = (lat, lng) => {
        setFormData((prev) => {
            if (mapTarget === 'pickup') {
                return { ...prev, pickupLatitude: lat, pickupLongitude: lng };
            } else if (mapTarget === 'drop') {
                return { ...prev, dropLatitude: lat, dropLongitude: lng };
            }
            return prev;
        });
        handleCloseMap(); // Close map after selection
    };

        const InputField1 = ({ label, name, value, onChange, ...props }) => {
        return (
            <div className="mb-4">
                <label htmlFor={name} className="block text-sm font-medium text-gray-700">
                    {label}
                    {props.required && <span className="text-red-500 ml-1">*</span>}
                </label>
                <input
                    type="text"
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    // CRITICAL: Spread all collected props onto the native input element
                    {...props}
                    className={`mt-1 block w-full rounded-md shadow-sm p-2 
          ${props.readOnly ? 'bg-gray-100 text-gray-600 cursor-default' : 'border-gray-300 focus:ring-green-500 focus:border-green-500'}
        `}
                />
            </div>
        );
    };

    // Determine initial coordinates to show in the map modal based on the current target
    const initialLat = mapTarget === 'pickup' ? formData.pickupLatitude : formData.dropLatitude;
    const initialLng = mapTarget === 'pickup' ? formData.pickupLongitude : formData.dropLongitude;


    return (
        <div className="bg-white p-6 rounded-lg shadow-xl mb-8 border-t-4 border-green-600">
            <h2 className="text-2xl font-semibold mb-4 text-green-700">Schedule New Pickup/Delivery Task</h2>
            <form onSubmit={handleSubmit} className="space-y-6">

                {/* ... (Existing form fields: Task Type, Date, Time, Slot ID) ... */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <InputField1 label="Task Type" name="taskType" readOnly value={formData.taskType} onChange={handleChange} required />
                    <InputField label="Preferred Date" name="preferredDate" type="date" value={formData.preferredDate} onChange={handleChange} required />
                    {/* <InputField label="Preferred Time" name="preferredTime" type="time" value={formData.preferredTime} onChange={handleChange} required /> */}
                    {/* Time Slot Dropdown - Now populated from API data */}
                    <SelectField
                        label="Time Slot"
                        name="slotId"
                        value={formData.slotId}
                        onChange={handleChange}

                        required
                        // ✅ Use slotList and map it to { value, label } format
                        options={slotList.map(slot => ({
                            // value is the slot ID to be saved in formData
                            value: slot.id,

                            label: `${slot.startTime || '??:??'} - ${slot.endTime || '??:??'}`
                        }))}
                    />

                    {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t pt-4"> */}
                    <SelectField label="Priority" name="priority" value={formData.priority} onChange={handleChange} options={[{ value: 'HIGH', label: 'HIGH' }, { value: 'NORMAL', label: 'NORMAL' }]} required />
                    <div className="md:col-span-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="description">Description</label>
                        <textarea id="description" name="description" value={formData.description} onChange={handleChange} rows="3" className="w-full border border-gray-300 p-2 rounded-md focus:ring-green-500 focus:border-green-500"></textarea>
                    </div>
                    {/* </div> */}
                </div>

                {/* Submit Button */}
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full py-3 px-4 rounded-md text-white font-semibold tracking-wider transition duration-150 ${isSubmitting ? 'bg-green-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'
                        }`}
                >
                    {isSubmitting ? 'SCHEDULING...' : 'SCHEDULE TASK'}
                </button>
            </form>

            {/* Map Modal */}
            {/* Pass dynamic initial coords based on the target */}
            <MapModal
                isOpen={isMapOpen}
                onClose={handleCloseMap}
                initialLat={initialLat}
                initialLng={initialLng}
                onSaveLatLong={handleSaveLatLong}
            />
        </div>
    );
};

// --- Form Helper Components ---
const InputField = ({ label, name, type = "text", value, onChange, required = false, className = '' }) => (
    <div className={className}>
        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor={name}>{label}</label>
        <input
            type={type}
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            className="w-full border border-gray-300 p-2 rounded-md focus:ring-green-500 focus:border-green-500"
        />
    </div>
);

const SelectField = ({ label, name, value, onChange, options, required = false }) => (
    <div>
        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor={name}>{label}</label>
        <select
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            className="w-full border border-gray-300 p-2 rounded-md focus:ring-green-500 focus:border-green-500 bg-white"
        >
            {options?.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
            ))}
        </select>
    </div>
);

// =================================================================
// TASK LIST COMPONENT (The Table)
// =================================================================

const TaskList = ({ data, isLoading, showAlerts }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingTask, setEditingTask] = useState(null);

    const [selectedTask, setSelectedTask] = useState(null);

    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const [taskToCancel, setTaskToCancel] = useState(null);

    const storedUser = localStorage.getItem('user');
    const userInfo = JSON.parse(storedUser)

    const handleAction = async (action, payload) => {
        if (action === 'update') {
            try {
                const response = await updateClientTask(payload);

                if (response.status === 1) {
                    // Logic to update the task in your main list state...
                    // Example:
                    // setTaskList(prev => prev.map(t => t.id === payload.taskId ? response.data : t));

                    alert('Task updated successfully!');
                    // showSuccess(`Task updated successfully!`);
                    handleCloseEditModal();
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                    return { success: true }; // IMPORTANT: Return a success object
                } else {
                    alert(`Failed to update task: ${response.message || 'Unknown error'}`);
                    // showError("Sorry!", "Failed to create task");
                    return { success: false }; // Return a failure object
                }
            } catch (error) {
                console.error("Update API call failed:", error);
                // showError("Sorry!", "n error occurred while updating the task.");
                return { success: false };
            }
        }
        // ... handle other actions like 'delete'
    };

    // Helper function to open the modal with the correct task data
    const handleViewClick = (taskItem) => {
        setSelectedTask(taskItem);
    };

    // Helper function to close the modal
    const handleCloseModal = () => {
        setSelectedTask(null);
    };

    // --- 3. New Handlers for Editing ---
    const handleEditClick = (taskItem) => {
        setEditingTask(taskItem);
    };
    const handleCloseEditModal = () => {
        setEditingTask(null);
    };
    const handleUpdateSubmit = async (payload) => {
        // This function will be called by the modal when the user saves changes
        const result = await handleAction('update', payload); // Pass the action and data up to the parent
        if (result && result.success) {
            handleCloseEditModal();
        } // Close the modal after submitting
    };

    const handleOpenCancelModal = (item) => {
        // 'item' is correctly passed here from the button onClick
        setTaskToCancel({
            taskId: item.id,
            userId: userInfo.id
        });
        setIsCancelModalOpen(true);
    };
    const handleCloseCancelModal = () => {
        setIsCancelModalOpen(false);
        setTaskToCancel(null);
    };

    // 3. Runs after a successful API call
    const handleCancelSuccess = (message) => {
        console.log("0000000000000000000: ", message)
    };



    if (isLoading && data.length === 0) {
        return <p className="p-4 text-center text-green-600 font-medium">Loading tasks...</p>;
    }

    if (!data || data.length === 0) {
        return <p className="p-4 text-center text-gray-500">No pending tasks found.</p>;
    }

    const columns = ["ID", "Type", "Date/Time", "Assigned To", "Slot Time", "Priority", "Status", "Actions"];


    // Helper to render status badge
    const StatusBadge = ({ status }) => {
        // Ensure status is handled safely, defaulting to UNKNOWN if null/undefined
        const statusText = status?.toUpperCase() || 'UNKNOWN';
        let colorClass;

        if (statusText === 'PENDING') {
            colorClass = 'bg-yellow-100 text-yellow-800';
        } else if (statusText === 'COMPLETED') {
            colorClass = 'bg-green-100 text-green-800';
        } else if (statusText === 'HIGH') {
            // Assuming 'HIGH' priority might also use a red color, keep this logic
            colorClass = 'bg-red-100 text-red-800';
        } else if (statusText === 'CANCELLED') { // <--- 🌟 NEW CONDITION ADDED HERE 🌟
            colorClass = 'bg-red-500 text-white'; // Using a darker red background with white text for high contrast
        } else {
            colorClass = 'bg-gray-100 text-gray-800';
        }

        return (
            <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${colorClass}`}>
                {statusText}
            </span>
        );
    };

    const StatusBadge2 = ({ status }) => {
        const displayStatus = status.toLowerCase() === "handovered" ? "DELIVERED" : status;

        const getBadgeClass = (status) => {
            switch (status.toLowerCase()) {
                case "completed":
                case "delivered":
                    return "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800";
                case "pending":
                    return "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800";
                case "cancelled":
                    return "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800";
                default:
                    return "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800";
            }
        };

        return <span className={getBadgeClass(displayStatus)}>{displayStatus}</span>;
    };


    return (
        <div className="bg-white p-6 rounded-lg shadow-xl border-t-4 border-green-600">
            <h2 className="text-2xl font-semibold mb-4 text-green-700">Scheduled Tasks ({data.length})</h2>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-green-50">
                        <tr>
                            {columns?.map(col => (
                                <th key={col} className="px-6 py-3 text-left text-xs font-medium text-green-800 uppercase tracking-wider">
                                    {col}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {data?.map((item) => {
                            const { dateStr, timeStr } = formatDateTime(item.preferredDate);
                            return (
                                <tr key={item.id} className="hover:bg-gray-50">
                                    {/* Data Cells */}
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.id}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.taskType}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{dateStr} @ {timeStr}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.assignedUser?.employeeName || 'Pending'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item?.slot?.startTime} - {item?.slot?.endTime}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm"><StatusBadge status={item.priority} /></td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                                        <StatusBadge2 status={item.status} />
                                    </td>

                                    {/* Actions Cell */}
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex gap-1">

                                        {/* Always allow View */}
                                        <button onClick={() => handleViewClick(item)} className=" text-white font-sm py-2 px-3 rounded text-sm view_btn">
                                            View
                                        </button>

                                        {/* Logic Check: Determine if the button should be disabled */}
                                        {/* isDisabled is TRUE if the status is CANCELLED OR ASSIGNED */}
                                        {/* We use OR (||) here because if either is true, the action should be blocked. */}
                                        {/* Using item.status?.toUpperCase() ensures safe access and case-insensitivity. */}
                                        {(() => {
                                            const status = item.status?.toUpperCase();
                                            const isDisabled = status != 'NEW_REQUEST';

                                            return (
                                                <>
                                                    {/* Edit Button */}
                                                    <button
                                                        onClick={() => handleEditClick(item)}
                                                        disabled={isDisabled}
                                                        className={` text-white font-sm py-2 px-3 rounded text-sm theme_btn 
                                                        ${isDisabled
                                                                ? 'text-gray-400 cursor-not-allowed'
                                                                : 'text-blue-600 hover:text-blue-800'}`
                                                        }
                                                    >
                                                        Edit
                                                    </button>

                                                    {/* Cancel Button */}
                                                    <button
                                                        onClick={() => handleOpenCancelModal(item)}
                                                        disabled={isDisabled}
                                                        className={` text-white font-sm py-2 px-3 rounded text-sm  cancel_btn
                                                        ${isDisabled
                                                                ? 'text-gray-400 cursor-not-allowed'
                                                                : 'text-red-600 hover:text-red-800'}`
                                                        }
                                                    >
                                                        Cancel
                                                    </button>
                                                </>
                                            );
                                        })()}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>

                {selectedTask && (
                    <TaskViewModal
                        taskData={selectedTask}
                        isOpen={!!selectedTask}
                        onClose={handleCloseModal}
                    />
                )}

                {editingTask && (
                    <UpdateTaskModal
                        taskData={editingTask}
                        isOpen={!!editingTask}
                        onClose={handleCloseEditModal}
                        onSubmit={handleUpdateSubmit}
                    />
                )}

                <CancelClientTaskModal
                    isOpen={isCancelModalOpen}
                    onClose={handleCloseCancelModal}
                    taskToCancel={taskToCancel} // Pass the task object containing IDs
                    onSuccess={handleCancelSuccess}
                // cancelTaskApi={cancelTaskApi} // Pass the API function if you prefer
                />

            </div>

        </div>
    );
};

export default ClientTask;


